import { c as _c } from "react/compiler-runtime";
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
interface useResetFunnelStepPageTemplateProps {
  funnelId: FunnelId;
  funnelStepId: FunnelStepId;
}
export function useResetFunnelStepPageTemplate(t0) {
  const $ = _c(3);
  const {
    funnelId,
    funnelStepId
  } = t0;
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  let t1;
  if ($[0] !== funnelStepId || $[1] !== mutateFunnelStepsList) {
    const resetFunction = async () => {
      await mutateFunnelStepsList(data => {
        if (data) {
          return data.map(dataFunnelStep => {
            if (dataFunnelStep.id === funnelStepId) {
              return {
                ...dataFunnelStep,
                page: null
              };
            }
            return dataFunnelStep;
          });
        }
      }, false);
    };
    t1 = {
      resetFunction
    };
    $[0] = funnelStepId;
    $[1] = mutateFunnelStepsList;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}